import { ace_index } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export function options({ url: { service: baseURL }, token }: IAPI) {
  return (): Promise<ace_index.FindOptions> =>
    send({
      baseURL,
      token,
      path: '/ace-index/find/options',
      method: 'GET',
    });
}
